import {Component, Input} from '@angular/core';

@Component({
  selector: 'gn-video',
  template: `
    <video width="100%" height="100%" [srcObject]="stream" [autoplay]="autoplay"></video>
  `
})
export class GnVideoComponent {

  @Input() stream: MediaStream;
  @Input() autoplay = true;

  close(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
      this.stream = null;
    }
  }

}
